














































































































































































































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import DialogConnector from '@/connector/Dialog.vue';
import PromotionService from '@/services/PromotionService';

const promotionService = new PromotionService();

@Component({
  components: {
    DialogConnector,
  },
})
export default class PromotionDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  async joinPromotion(promotionId: any) {
    try {
      await promotionService.acceptPromotion({ promotionId });
      this.$store.commit('Snackbar/showNotification', { message: 'รับโปรโมชั่นสำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }
}
